<template>
  <div class="wapper" style="padding-bottom:0">
    <div class="about mid-width">
      <div class="title">
        About US
      </div>
     <div class="about_text">
       <!-- <p>律信网，是一家综合性合伙工作室。律信现有执业律师21名，其中合伙人11名，聘用律师9名，兼职律师1名。律信意为“君子之合，志存高远”，律信人秉承“客户法律利益至上”的原则，汇集了高层次、综合型专业法律人才，以认真严谨的作风，为社会公众提供优质、高效的法律服务是律信人一如既往的承诺。“诚信为本，理法为先”是我们的执业风格。律信律师大多毕业于国内著名法学院或知名大学的法律本科，部份拥有博士或者硕士学位，并拥有资深法官、庭长、高校任教、担任政府公职、企业高层、市律师协会管理等经历和背景，是一支高素质的律师团队。律信律师在刑事、行政、民商事案件中成功代理了大量有社会影响和案例价值的案件，在为客户取得了良好的社会与经济效益的同时，也取得了良好的声誉。对于复杂、疑难的个案，律信集中全所律师的智慧，力求为客户提供最佳、最有效的服务。律信律师在房地产、建筑工程、规划、土地等法律服务领域具有独特的人才和不可替代的专业特色，专业领域内已达到 “人无我有 ”、“独一无二”的高度。不少经典案例已被法院和权威法律文献库选中，奠定了律信同仁深厚的法律服务功底和广博的法律服务经验以及全方位的服务能力。律信同仁在为客户进行全盘精确法律策划、避免法律风险和精心维护合同权益、诉讼策略和技能方面赢得了社会和各界人士的认可。 与此同时，律信同仁以不同方式尽力回报社会，积极参与社会公益活动，为和谐社会、和谐社区贡献绵薄之力。共同的执业理念、规范的管理体系、高素质的法律人才、良好的客户网络，为律信同仁服务客户、服务社会和持续发展奠定了坚实基础。我们承诺，您的委托是正确的选择；我们期待，您能感受我们出色的服务。</p> -->
     </div>
    </div>
    <div class="contact_us">
      <div class="mid-width">
        <div class="col-left">
          <dl class="clearfix">
            <dt class="left-one">联系我们</dt>
            <dd>
              <p>地址：上海市延安西路1228弄嘉利大厦17楼B座</p>
              <p>邮编：200000</p>
            </dd>
            <dt class="left-tow">客户服务</dt>
            <dd>
              <p>如果您在访问网站的过程中有任何疑问请您与我们联系。</p>
              <p>客服电话：186-2195-1461</p>
              <p>工作时间：9:00 - 21:00</p>
              <p>电子邮件：ericxian@yeah.net</p>
            </dd>
          </dl>
          
        </div>
        <div class="col-right">
            <!-- <baidu-map class="map"></baidu-map>             -->
            <baidu-map class="map" :center="{lng: 121.43429, lat: 31.21616}" :zoom="15">
              <bm-marker :position="{lng: 121.43429, lat: 31.21616}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
                <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map>
                <bm-label content="律信网" :labelStyle="{color: 'red', fontSize : '16px'}" :offset="{width: -75, height: 40}"/>
              </bm-marker>
            </baidu-map>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {

      }
    }
    
  }
</script>
<style lang="scss" scoped>
  @import '~@/common/css/common';
  @import '~@/common/css/news_success';
  .about {
    .title {
      width: 100%;
      height: 250px;
      background: url("./img0.jpg") no-repeat;
      background-size:100% 100%;
      text-align: center;
      line-height: 250px;
      font-size: 48px;
      color: #ffffff;
    }
    .about_text {
      margin-top: 30px;
      p {
        font-size: 15px;
        line-height: 38px;
        color: #333;
        text-indent: 2em;
      }
    }
  }
  .contact_us {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    background: rgba(245, 245, 245, 1);
    margin: 45px 0 0px;
    font-size: 15px;
    color: #333;
    height: 500px;
    .col-left {
      float: left;
      width: 500px;
      .left-one {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 30px;
      }
      .left-tow  {
        font-weight: bold;
        font-size: 18px;
        margin-top: 50px;
        margin-bottom: 30px;
      }
      dd {
        font-size: 15px;
        line-height: 38px; 
      }
    }
    .col-right {
      float: left;
      width: 700px;
      .map {
        width: 700px;
        height: 400px;
      }
    }
    
    
  }
</style>





// WEBPACK FOOTER //
// src/components/about/about.vue